import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { Tie } from '../../_shared/models/tie.model';
import { IntBodyComponent } from '../int-body/int-body.component';
import { CommonModule } from '@angular/common';
import { ScoreboardService } from '../../scoreboard/scoreboard.service';
import { ThemeService } from '../../_core/services/theme.service';
import { TieDetailsService } from '../../ties/tie-details/tie-details.service';
import { Subject } from 'rxjs';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';

@Component({
    selector: 'app-int-match-score',
    templateUrl: './int-match-score.component.html',
    styleUrls: ['./int-match-score.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntMatchScoreComponent implements OnInit, OnChanges {
    @Input() match: Match;
    @Input() tie: Tie;
    @Input({ required: false }) matchTotalScore: any;
    @Input({ required: false }) summaryView: any;
    @ViewChild(IntBodyComponent) sbBody: IntBodyComponent;

    private scoreboardService = inject(ScoreboardService);
    public themeService = inject(ThemeService);
    public tieDetailsService = inject(TieDetailsService);
    private bhs = inject(BoardHelpService);
    private readonly destroy$: Subject<void> = new Subject();

    side1Color: string;
    side2Color: string;
    teamLogoSide1: string = '';
    teamLogoSide2: string = '';
    teamProfileImageSide1: string = '';
    teamProfileImageSide2: string = '';
    teamNameSide1: string;
    teamNameSide2: string;
    pointScoreSide1: string;
    pointScoreSide2: string; 

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tie']?.currentValue) {
            this.tie = changes['tie'].currentValue;
            this.updateMatchDetails();
        }
    }

    private updateMatchDetails(): void {
        this.getTeamColors();
        this.getTeamAssets();
        
        const scores = this.tieDetailsService.getScore(this.tie.score);
        [this.pointScoreSide1, this.pointScoreSide2] = scores;
    }

    private getTeamColors(): void {
        if (this.tie) {
            this.side1Color = this.tie?.sides[0]?.team ? this.scoreboardService.getColor(1, this.tie) : this.getDefaultColor();
            this.side2Color = this.tie?.sides[1]?.team ? this.scoreboardService.getColor(2, this.tie) : this.getDefaultColor();
        } else {
            this.side1Color = this.side2Color = this.getDefaultColor();
        }
    }

    private getDefaultColor(): string {
        return this.themeService.isDarkMode ? '#8bc34a' : '#009688';
    }

    private getTeamAssets(): void {
        if (!this.tie) return;

        this.teamLogoSide1 = this.tie?.sides[0]?.team?.logo ?? '';
        this.teamLogoSide2 = this.tie?.sides[1]?.team?.logo ?? '';
        this.teamProfileImageSide1 = this.tie?.sides[0]?.team?.profile_image ?? '';
        this.teamProfileImageSide2 = this.tie?.sides[1]?.team?.profile_image ?? '';
    }
}
